import { push, replace } from 'connected-react-router';
import { upsellTransition, UpsellTransitionStages } from '@ecs-uk/web-common-mobile-view-helpers';

import { relativeUrls, splitsList } from '../../../constants';
import { selectIsFlexUser } from '../../../services/responseUtility/entitlementsSelectors';
import { PAYMENT_ERROR_GROUPS, PAYMENT_ERROR_TYPES } from '../constants/paymentErrors';
import confirmSelect from '../../../actions/offers/confirmSelect';
import { isAnnualBillingFrequency } from '../../../helpers/flex-helpers/flexBillingFrequency';

const paymentCompleteTransition =
  (paymentContext, fulfillmentStatus, productFamilyDuringPurchase) => async (dispatch, getState) => {
    const isGuardEnabled = getState().split?.treatments?.[splitsList.preventDuplicatePayment];
    const isFlexSplitEnabled = getState().split?.treatments?.[splitsList.isFlexSplitEnabled];
    const isNewDesignEnabled = getState().split?.treatments?.[splitsList.prodmoveNewDesign];
    const isFlexUser = selectIsFlexUser(getState());

    const isFlex = (isFlexSplitEnabled || isFlexUser) && isNewDesignEnabled;

    const {
      raisePaymentError,
      restartPaymentFlow,
      resolvedUpgradeOffer,
      resolvedCurrentSubscription,
      resolvedIsTrial,
      isFlexFlow,
      isWebview,
      tokens,
      selectedPlanOverride,
    } = paymentContext;
    const upgradeOfferPrice = selectedPlanOverride?.price ?? resolvedUpgradeOffer.terms?.[0]?.price;
    const billingFrequency =
      selectedPlanOverride?.billingFrequency ?? resolvedUpgradeOffer.terms?.[0]?.billingFrequency;
    const paymentMethodType = tokens?.paymentType;
    const isFlexUserMigrationFailed = tokens?.flexUserMigrationFailed === true;

    /*
      The flex thank you page is a dumb component - everything it needs that is only known during the payment journey
      is handed to it through the route state. Data that changes as a result of the purchase (next billing date,
      pro rata price) is read from the store by the thanks landing page once it has refreshed it.
    */
    const flexThankYou = isFlexFlow
      ? {
          product: resolvedUpgradeOffer.family,
          previousProduct: resolvedCurrentSubscription?.family,
          hasFreeTrial: resolvedIsTrial,
          isTargetAnnual: isAnnualBillingFrequency(billingFrequency),
          isCurrentAnnual: isAnnualBillingFrequency(resolvedCurrentSubscription?.billingFrequency),
          price: upgradeOfferPrice,
          previousPlanPrice: resolvedCurrentSubscription?.price ?? null,
        }
      : null;

    if (fulfillmentStatus === true) {
      const selectionData = {
        cancel: false,
        complimentary: false,
        family: resolvedUpgradeOffer.family,
        price: upgradeOfferPrice,
        ...(billingFrequency ? { billingFrequency } : {}),
        freeTrial: resolvedIsTrial,
        oldProduct: productFamilyDuringPurchase,
      };

      confirmSelect(selectionData)(dispatch);

      // Purchase successful, we should now be able to make a change to the customers subscription
      const shouldSendWebviewSuccess = isWebview;
      const shouldLockWebview = isWebview && isFlex;
      const shouldNavigateToThanks = !isWebview || isFlex;

      if (shouldLockWebview) {
        upsellTransition({
          stage: UpsellTransitionStages.LOCK,
        });
      }

      if (shouldSendWebviewSuccess) {
        upsellTransition({
          stage: UpsellTransitionStages.SUCCESS,
          paymentMethod: paymentMethodType,
          isFlexUser: isFlex,
        });
      }

      if (shouldNavigateToThanks) {
        dispatch(
          (isGuardEnabled ? replace : push)(isWebview ? relativeUrls.mobileThanks : relativeUrls.thanks, {
            paymentMethod: paymentMethodType,
            isEligibleForTrial: resolvedIsTrial,
            isValidRedirect: true,
            ...(isFlexUserMigrationFailed ? { flexUserMigrationFailed: true } : {}),
            ...(flexThankYou ? { flexThankYou } : {}),
          })
        );
      }

      return true;
    }

    raisePaymentError({
      message: 'UNSUCCESSFUL_FULFILLMENT_ATTEMPT',
      group: PAYMENT_ERROR_GROUPS.FULFILLMENT,
      type: PAYMENT_ERROR_TYPES.FULFILLMENT.INITIATING_FULFILLMENT,
    });
    restartPaymentFlow();

    return false;
  };

export default paymentCompleteTransition;
